import { atom } from 'jotai';
import { ColumnState } from 'ag-grid-community';

export const rowGroupColumnsState = atom<ColumnState[]>([]);

export const collapsedDealStages = atom<Record<string, boolean>>({});

export const isFirstRenderDonePFJ = atom<boolean>(false);
